import { CurrentPlanVariant, type VariantCopy } from './types';

export const CURRENT_PLAN_BANNER_ID = 'current-plan-banner-scroll-target';

export const VARIANT_COPY: Record<CurrentPlanVariant, VariantCopy> = {
  [CurrentPlanVariant.CUSTOM]: {
    title: "You're on a custom agreement",
    summaryTitle: 'Custom',
    inclusionTitle: "What's included in your custom plan?",
    inclusionKicker: 'Custom Agreement',
  },
  [CurrentPlanVariant.LEGACY]: {
    title: "You're on a Legacy agreement",
    summaryTitle: 'Legacy',
    inclusionTitle: "What's included in your Legacy plan?",
    inclusionKicker: 'Legacy pricing',
  },
};
